export const IOS_LINK = "https://apps.apple.com/gb/app/whoppah/id1458122175";
export const ANDROID_LINK =
  "https://play.google.com/store/apps/details?id=com.whoppah";
